import React, { Suspense } from 'react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import App from './components/App/App';
import i18n from './utils/i18n';
import { MixpanelProvider } from './utils/mixpanel';
import { AppContextProvider } from './utils/AppContext';
import { Provider as DesignSysProvider } from '@optibus-internal/ops-designsys';
import { sanitizeReferrerAndReferringDomain } from './utils/generalUtils';

declare global {
  interface Window {
    grecaptcha: any;
  }
}

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://25e407f5de65421480a80cf9e9427fc3@o285998.ingest.sentry.io/5848306',
    environment: window.location.hostname.includes('-')
      ? window.location.hostname.replace('-login.optibus.co', '')
      : 'titus',
    integrations: [new Integrations.BrowserTracing()],
    release: process.env.REACT_APP_TAG ? process.env.REACT_APP_TAG.split('..').pop() : undefined,
    tracesSampleRate: 0.0001,
    beforeSend(event) {
      if (event.request?.headers?.Referer) {
        try {
          const { referrer } = sanitizeReferrerAndReferringDomain(event.request.headers.Referer);
          event.request.headers.Referer = referrer;
        } catch {
          /* eslint-disable no-empty */
        }
      }
      return event;
    }
  });
}

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<></>}>
      <DesignSysProvider>
        <I18nextProvider i18n={i18n}>
          <AppContextProvider>
            <MixpanelProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </MixpanelProvider>
          </AppContextProvider>
        </I18nextProvider>
      </DesignSysProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);
